
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { PostInbodyDetail } from "@/request/workstation";
@Component({})
export default class Name extends Vue {
  @Prop()
  private id: any;
  @Watch("id", { immediate: true })
  private idChange() {
    if (this.id) {
      this.getData();
    }
  }
  private data: any = [];
  private get patient() {
    return this.$store.state.patient;
  }
  private getData() {
    const params: any = {
      patient_id: this.patient.patient_id,
      inbody_data_id: this.id,
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    PostInbodyDetail(this, params)
      .then((data: any) => {
        loading.close();
        this.data = data;
      })
      .catch(() => {
        loading.close();
      });
  }
}
